// ! rename the function to align with the widget name
export const onThisPage = () => {
    const el = document.querySelector('.curious-on-this-page');
    if (!el) return;

    // ------------------------------------------------------------

    function generateTOCHTML(headings) {
        if (headings.length === 0) {
            return `<p>No headings found on this page.</p>`;
        }
        
        let tocItems = '';
        let isInH3Group = false;
        
        headings.forEach((heading, index) => {
            const level = parseInt(heading.tagName.charAt(1)); // 2 for H2, 3 for H3
            const text = heading.textContent;
            const id = heading.id;
            
            if (level === 2) {
                // Close previous H3 group if we were in one
                if (isInH3Group) {
                    tocItems += `
                    </ul>
                </li>`;
                    isInH3Group = false;
                }
                
                // Check if next heading is H3 to determine if we need a nested structure
                const nextHeading = headings[index + 1];
                const hasH3Children = nextHeading && parseInt(nextHeading.tagName.charAt(1)) === 3;
                
                if (hasH3Children) {
                    tocItems += `
                <li>
                    <a href="#${id}" data-heading-id="${id}">${text}</a>
                    <ul class="toc-list">`;
                    isInH3Group = true;
                } else {
                    tocItems += `
                <li><a href="#${id}" data-heading-id="${id}">${text}</a></li>`;
                }
            } else if (level === 3) {
                tocItems += `
                        <li><a href="#${id}" class="h3-link" data-heading-id="${id}">${text}</a></li>`;
            }
        });
        
        // Close final H3 group if needed
        if (isInH3Group) {
            tocItems += `
                    </ul>
                </li>`;
        }
        
        return `
            <ul class="toc-list menu-maker">${tocItems}
            </ul>
        `;
    }

    const mainContainer = document.querySelector('article')
    const headings = mainContainer.querySelectorAll('h2, h3');
        
    // Generate IDs and click handlers
    headings.forEach((heading) => {
        const id = heading.textContent
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '');
        
        heading.id = id;
        heading.addEventListener('click', () => {
            const url = `${window.location.href.split('#')[0]}#${id}`;
            navigator.clipboard.writeText(url);
        });
    });

    const html = generateTOCHTML(headings);
    const container = document.querySelector('.on-this-page-container');
    container.innerHTML = html;

    // ------------------------------------------------------------
    // Intersection Observer for visibility tracking
    const observerOptions = {
        root: null,
        rootMargin: '-10% 0px -70% 0px', // Only consider visible when in the top 30% of viewport
        threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const headingId = entry.target.id;
            const menuLink = container.querySelector(`a[data-heading-id="${headingId}"]`);
            
            if (menuLink && entry.isIntersecting) {
                // Remove visible class from all other menu items
                container.querySelectorAll('a.visible').forEach(link => {
                    link.classList.remove('visible');
                });
                
                // Add visible class to current menu item
                menuLink.classList.add('visible');
            }
        });
    }, observerOptions);

    // Observe all headings
    headings.forEach(heading => {
        observer.observe(heading);
    });

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js
}